<template>
  <Breadcrumbs main="Setting" mains="Menu Management" title="Menu Management" />
  <div class="container-fluid default-dashboard">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
              <h5>Menu Management</h5>
              <button class="btn btn-primary" @click="openAddModal">
                Add New Menu
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="menu-tree">
              <ul class="tree-root">
                <li v-for="menu in treeData" :key="menu.id" class="tree-node" draggable="true" 
                    @dragstart="dragStart($event, menu)" 
                    @dragover.prevent 
                    @drop="handleDrop($event, menu)">
                  <div class="tree-content" @click="handleNodeClick(menu)">
                    <div class="d-flex align-items-center">
                      <vue-feather v-if="menu.Icon" :type="menu.Icon" class="me-2"></vue-feather>
                      <span>{{ menu.Title }}</span>
                    </div>
                    <div class="badges">
                      <span v-if="menu.IsPinned" class="badge bg-primary me-1">Pinned</span>
                      <span v-if="menu.Bookmark" class="badge bg-info me-1">Bookmarked</span>
                      <span v-if="!menu.Active" class="badge bg-warning">Inactive</span>
                    </div>
                  </div>
                  <ul v-if="menu.Children && menu.Children.length > 0" class="tree-children">
                    <li v-for="child in menu.Children" :key="child.id" class="tree-node" draggable="true"
                        @dragstart="dragStart($event, child)" 
                        @dragover.prevent 
                        @drop="handleDrop($event, child)">
                      <div class="tree-content" @click="handleNodeClick(child)">
                        <div class="d-flex align-items-center">
                          <vue-feather v-if="child.Icon" :type="child.Icon" class="me-2"></vue-feather>
                          <span>{{ child.Title }}</span>
                        </div>
                        <div class="badges">
                          <span v-if="child.IsPinned" class="badge bg-primary me-1">Pinned</span>
                          <span v-if="child.Bookmark" class="badge bg-info me-1">Bookmarked</span>
                          <span v-if="!child.Active" class="badge bg-warning">Inactive</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form Modal -->
    <div class="modal fade" :class="{ 'show': showModal }" :style="{ display: showModal ? 'block' : 'none' }" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ modalTitle }}</h5>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="handleSubmit">
              <div class="row">
                <div class="col-md-6 mb-2">
                  <label>Head Title 1</label>
                  <input v-model="formData.HeadTitle1" class="form-control" />
                </div>
                <div class="col-md-6 mb-2">
                  <label>Head Title 2</label>
                  <input v-model="formData.HeadTitle2" class="form-control" />
                </div>
                <div class="col-md-6 mb-2">
                  <label>Title</label>
                  <input v-model="formData.Title" class="form-control" required />
                </div>
                <div class="col-md-6 mb-2">
                  <label>Icon</label>
                  <div class="icon-select-wrapper">
                    <input readonly :value="formData.Icon" class="form-control" @click="showIconList = !showIconList" />
                    <vue-feather v-if="formData.Icon" :type="formData.Icon" class="selected-icon"></vue-feather>
                    <div v-show="showIconList" class="icon-list">
                      <div class="icon-search mb-2">
                        <input type="text" class="form-control" v-model="iconSearch" placeholder="Search icon..." @click.stop />
                      </div>
                      <div class="icon-grid">
                        <div v-for="icon in filteredIcons" :key="icon" class="icon-item" @click="selectIcon('Icon', icon)">
                          <vue-feather :type="icon"></vue-feather>
                          <small>{{ icon }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <label>Icon 1</label>
                  <div class="icon-select-wrapper">
                    <input readonly :value="formData.Icon1" class="form-control" @click="showIcon1List = !showIcon1List" />
                    <vue-feather v-if="formData.Icon1" :type="formData.Icon1" class="selected-icon"></vue-feather>
                    <div v-show="showIcon1List" class="icon-list">
                      <div class="icon-search mb-2">
                        <input type="text" class="form-control" v-model="iconSearch" placeholder="Search icon..." @click.stop />
                      </div>
                      <div class="icon-grid">
                        <div v-for="icon in filteredIcons" :key="icon" class="icon-item" @click="selectIcon('Icon1', icon)">
                          <vue-feather :type="icon"></vue-feather>
                          <small>{{ icon }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <label>Menu Type</label>
                  <select v-model="formData.MenuType" class="form-control">
                    <option value="link">Link</option>
                    <option value="group">Group</option>
                  </select>
                </div>
                <div class="col-md-6 mb-2">
                  <label>Badge Type</label>
                  <input v-model="formData.BadgeType" class="form-control" />
                </div>
                <div class="col-md-6 mb-2">
                  <label>Path</label>
                  <input v-model="formData.Path" class="form-control" />
                </div>
                <div class="col-md-6 mb-2">
                  <label>Badge</label>
                  <input v-model="formData.Badge" class="form-control" />
                </div>
                <div class="col-md-6 mb-2">
                  <label>Parent</label>
                  <select v-model="formData.ParentID" class="form-control">
                    <option :value="null">No Parent</option>
                    <option v-for="menu in flatMenus" :key="menu.id" :value="menu.id">
                      {{ menu.Title }}
                    </option>
                  </select>
                </div>
                <div class="col-12">
                  <div class="form-check mb-2">
                    <input v-model="formData.Active" type="checkbox" class="form-check-input" />
                    <label class="form-check-label">Active</label>
                  </div>
                  <div class="form-check mb-2">
                    <input v-model="formData.IsPinned" type="checkbox" class="form-check-input" />
                    <label class="form-check-label">Pinned</label>
                  </div>
                  <div class="form-check mb-2">
                    <input v-model="formData.Bookmark" type="checkbox" class="form-check-input" />
                    <label class="form-check-label">Bookmark</label>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
                <button type="submit" class="btn btn-primary">Save</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade" :class="{ 'show': showModal }" v-if="showModal"></div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue'
import VueFeather from 'vue-feather'

interface MenuItem {
  id: number;
  HeadTitle1?: string;
  HeadTitle2?: string;
  Title: string;
  Icon?: string;
  Icon1?: string;
  MenuType: 'link' | 'group';
  BadgeType?: string;
  Active: boolean;
  IsPinned: boolean;
  Path?: string;
  Badge?: string;
  ParentID: number | null;
  Children: MenuItem[];
  Bookmark: boolean;
}

const showModal = ref(false)
const showIconList = ref(false)
const showIcon1List = ref(false)
const iconSearch = ref('')
const modalTitle = ref('Add New Menu')
const selectedMenu = ref<MenuItem | null>(null)

// Sample data
const initialMenus: MenuItem[] = [
  {
    id: 1,
    Title: "Dashboard",
    Icon: "home",
    MenuType: "link",
    Active: true,
    IsPinned: true,
    Path: "/dashboard",
    ParentID: null,
    Children: [],
    Bookmark: true
  },
  {
    id: 2,
    Title: "Settings",
    Icon: "settings",
    MenuType: "group",
    Active: true,
    IsPinned: false,
    ParentID: null,
    Children: [
      {
        id: 3,
        Title: "Menu Management",
        Icon: "list",
        MenuType: "link",
        Active: true,
        IsPinned: false,
        Path: "/setting/menu",
        ParentID: 2,
        Children: [],
        Bookmark: false
      },
      {
        id: 4,
        Title: "User Management",
        Icon: "users",
        MenuType: "link",
        Active: true,
        IsPinned: false,
        Path: "/setting/users",
        ParentID: 2,
        Children: [],
        Bookmark: false
      }
    ],
    Bookmark: false
  },
  {
    id: 5,
    HeadTitle1: "Apps",
    Title: "Email",
    Icon: "mail",
    MenuType: "link",
    Active: true,
    IsPinned: false,
    Path: "/apps/email",
    ParentID: null,
    Children: [],
    Bookmark: true
  }
]

const menus = ref<MenuItem[]>(initialMenus)

const formData = ref<Partial<MenuItem>>({
  HeadTitle1: '',
  HeadTitle2: '',
  Title: '',
  Icon: '',
  Icon1: '',
  MenuType: 'link',
  BadgeType: '',
  Active: true,
  IsPinned: false,
  Path: '',
  Badge: '',
  ParentID: null,
  Children: [],
  Bookmark: false
})

// Feather icons list
const featherIcons = [
  'home', 'settings', 'user', 'users', 'file', 'folder',
  'calendar', 'mail', 'message-square', 'bell',
  'bookmark', 'heart', 'star', 'check-square',
  'list', 'grid', 'menu', 'search', 'filter'
]

const filteredIcons = computed(() => {
  return featherIcons.filter(icon => 
    icon.toLowerCase().includes(iconSearch.value.toLowerCase())
  )
})

const treeData = computed(() => {
  const buildTree = (parentId: number | null): MenuItem[] => {
    return menus.value
      .filter(item => item.ParentID === parentId)
      .map(item => ({
        ...item,
        Children: buildTree(item.id)
      }))
  }
  return buildTree(null)
})

const flatMenus = computed(() => 
  menus.value.filter(menu => menu.MenuType === 'group')
)

const openAddModal = () => {
  selectedMenu.value = null
  modalTitle.value = 'Add New Menu'
  formData.value = {
    HeadTitle1: '',
    HeadTitle2: '',
    Title: '',
    Icon: '',
    Icon1: '',
    MenuType: 'link',
    BadgeType: '',
    Active: true,
    IsPinned: false,
    Path: '',
    Badge: '',
    ParentID: null,
    Children: [],
    Bookmark: false
  }
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
  showIconList.value = false
  showIcon1List.value = false
}

const handleNodeClick = (node: MenuItem) => {
  selectedMenu.value = node
  modalTitle.value = 'Edit Menu'
  formData.value = { ...node }
  showModal.value = true
}

const selectIcon = (field: 'Icon' | 'Icon1', icon: string) => {
  formData.value[field] = icon
  if (field === 'Icon') showIconList.value = false
  else showIcon1List.value = false
}

const handleSubmit = () => {
  if (selectedMenu.value) {
    // Edit existing menu
    const updateMenu = (items: MenuItem[]): MenuItem[] => {
      return items.map(item => {
        if (item.id === selectedMenu.value?.id) {
          return { ...item, ...formData.value } as MenuItem
        } else if (item.Children && item.Children.length > 0) {
          return { ...item, Children: updateMenu(item.Children) }
        }
        return item
      })
    }
    menus.value = updateMenu(menus.value)
  } else {
    // Add new menu
    const newMenu: MenuItem = {
      id: Date.now(),
      Title: formData.value.Title || '',
      MenuType: formData.value.MenuType || 'link',
      Active: formData.value.Active || false,
      IsPinned: formData.value.IsPinned || false,
      Bookmark: formData.value.Bookmark || false,
      ParentID: formData.value.ParentID ?? null,
      Children: [],
      HeadTitle1: formData.value.HeadTitle1,
      HeadTitle2: formData.value.HeadTitle2,
      Icon: formData.value.Icon,
      Icon1: formData.value.Icon1,
      BadgeType: formData.value.BadgeType,
      Path: formData.value.Path,
      Badge: formData.value.Badge
    }
    menus.value.push(newMenu)
  }
  closeModal()
}

onMounted(() => {
  document.addEventListener('click', (e) => {
    if (!(e.target as HTMLElement).closest('.icon-select-wrapper')) {
      showIconList.value = false
      showIcon1List.value = false
    }
  })
})

// Add these new refs
const draggedItem = ref<MenuItem | null>(null)

// Add these new methods
const dragStart = (event: DragEvent, item: MenuItem) => {
  draggedItem.value = item
  if (event.dataTransfer) {
    event.dataTransfer.effectAllowed = 'move'
    event.dataTransfer.setData('text/plain', item.id.toString())
  }
}

const handleDrop = (event: DragEvent, target: MenuItem) => {
  event.preventDefault()
  
  if (!draggedItem.value || draggedItem.value.id === target.id) return
  
  // Don't allow dropping on own children
  const isOwnChild = (parent: MenuItem, child: MenuItem): boolean => {
    if (parent.Children.some(c => c.id === child.id)) return true
    return parent.Children.some(c => isOwnChild(c, child))
  }
  
  if (draggedItem.value.ParentID === null && isOwnChild(draggedItem.value, target)) return
  
  // Update the dragged item's parent
  const updateItemParent = (items: MenuItem[]): MenuItem[] => {
    return items.map(item => {
      if (item.id === draggedItem.value?.id) {
        return { ...item, ParentID: target.id }
      } else if (item.Children && item.Children.length > 0) {
        return { ...item, Children: updateItemParent(item.Children) }
      }
      return item
    })
  }
  
  // Remove the item from its current position
  const removeItem = (items: MenuItem[]): MenuItem[] => {
    return items.filter(item => {
      if (item.id === draggedItem.value?.id) return false
      if (item.Children && item.Children.length > 0) {
        item.Children = removeItem(item.Children)
      }
      return true
    })
  }
  
  // First remove the item from its current position
  let updatedMenus = removeItem([...menus.value])
  
  // Then add it back with the new parent
  if (draggedItem.value) {
    const updatedItem = { ...draggedItem.value, ParentID: target.id }
    updatedMenus.push(updatedItem)
  }
  
  menus.value = updatedMenus
  draggedItem.value = null
}
</script>

<style scoped>
.icon-select-wrapper {
  position: relative;
}

.icon-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 1rem;
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.icon-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
  gap: 0.5rem;
}

.icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.icon-item:hover {
  background-color: #f8f9fa;
  border-color: #adb5bd;
}

.selected-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.badges {
  display: flex;
  gap: 0.25rem;
}

.modal-backdrop.show {
  opacity: 0.5;
}

.menu-tree {
  padding: 1rem;
}

.tree-root {
  list-style: none;
  padding-left: 0;
}

.tree-children {
  list-style: none;
  padding-left: 2rem;
  margin-top: 0.5rem;
}

.tree-node {
  margin-bottom: 0.5rem;
  cursor: move; /* Show it's draggable */
}

.tree-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  background-color: white; /* Ensure background is visible */
}

.tree-content:hover {
  background-color: #f8f9fa;
}

/* Add these new styles for drag and drop visual feedback */
.tree-node.dragging {
  opacity: 0.5;
}

.tree-node.drop-target {
  border: 2px dashed #007bff;
}
</style>
                                                                                                                                                                        